import { RouteType } from "types/RouteType";
import WarrantyClaimWorkflowStore from "./WarrantyClaimWorkflowStore";

const WarrantyClaimWorkflowRoute: RouteType = {
  name: "Warranty Claim Workflow",
  path: "/workflows/warranty-claim",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Warranty Claim & Service",
      component: () => import("./WarrantyClaimWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./WarrantyClaimWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.warrantyClaimWorkflowStore) {
      rootStore.warrantyClaimWorkflowStore = new WarrantyClaimWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.warrantyClaimWorkflowStore as WarrantyClaimWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default WarrantyClaimWorkflowRoute;